import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import types from './types';

export default {
  async getErrorLogs({ commit }, payload) {
    try {
      commit(types.GET_ERROR_LOGS_START);
      const {
        data: { data },
      } = await apiCall({
        type: 'GET',
        url: URLS.errorLogs,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ERROR_LOGS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_ERROR_LOGS_FAILURE, message);
    }
  },

  async getErrorLogDetail({ commit }, id) {
    try {
      commit(types.GET_ERROR_LOG_DETAIL_START);
      const {
        data: { data },
      } = await apiCall({
        type: 'GET',
        url: `${URLS.errorLogs}/${id}`,
        isToken: true,
      });
      commit(types.GET_ERROR_LOG_DETAIL_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_ERROR_LOG_DETAIL_FAILURE, message);
    }
  },

  async getErrorStats({ commit }, payload) {
    try {
      commit(types.GET_ERROR_STATS_START);
      const {
        data: { data },
      } = await apiCall({
        type: 'GET',
        url: URLS.errorLogsStats,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ERROR_STATS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_ERROR_STATS_FAILURE, message);
    }
  },

  async resolveErrors({ commit, dispatch }, {
    ids, isResolved, note, filters,
  }) {
    try {
      commit(types.RESOLVE_ERRORS_START);
      await apiCall({
        type: 'PUT',
        url: URLS.errorLogsResolve,
        body: { ids, isResolved, note },
        isToken: true,
      });
      commit(types.RESOLVE_ERRORS_SUCCESS);
      notificationWithIcon('success', `${ids.length} error(s) ${isResolved ? 'resolved' : 'reopened'}`);
      if (filters) {
        dispatch('getErrorLogs', filters);
      }
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.RESOLVE_ERRORS_FAILURE, message);
    }
  },

  async deleteErrors({ commit, dispatch }, { payload, filters }) {
    try {
      commit(types.DELETE_ERRORS_START);
      const {
        data: { data },
      } = await apiCall({
        type: 'DELETE',
        url: URLS.errorLogs,
        body: payload,
        isToken: true,
      });
      commit(types.DELETE_ERRORS_SUCCESS);
      notificationWithIcon('success', `${data.deleted} error(s) deleted`);
      if (filters) {
        dispatch('getErrorLogs', filters);
      }
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.DELETE_ERRORS_FAILURE, message);
    }
  },

  clearDetail({ commit }) {
    commit(types.CLEAR_DETAIL);
  },
};
